export default "__VITE_ASSET__BiSAKy6G__"